import { useState, useEffect } from 'react';

export const usePartnerClientForm = (initForm) => {
  const [form, setForm] = useState(initForm);

  const handleChangeForm = (key, converter) => (value) => {
    const v = converter ? converter(value) : value;
    setForm({ ...form, [key]: v });
  };

  useEffect(() => setForm(initForm), [initForm]);

  return { form, setForm, handleChangeForm };
};
